import produce from 'immer';
import { SetDeviceResponse } from 'api/Responses/SetResponses';
import { PartAction } from './partActions';

export const initialPart: SetDeviceResponse = {
  ref: '',
  code: '',
  display_code: '',
  description: '',
  part_image_file: '',
  num_parts: '',
  cannulated: false,
  debris_prone: null,
  qty: '1',
  requires_inspection: null,
  additional_info: null,
  part_diagram: null,
  inspection_text: '',
  test_metadata: {},
  part_test_metadata: {},
  language_metadata: null,
  draft_exists: false,
  owned_by: null,
};

const partReducer = produce((part: SetDeviceResponse, action: PartAction) => {
  switch (action.type) {
    case 'REF':
      part.ref = action.payload;
      break;
    case 'QTY':
      part.qty = action.payload;
      break;
    case 'SEARCH':
      Object.assign(part, action.payload);
      // Assign to part specific metadata for usage in PartRow
      part.part_test_metadata = part.test_metadata;

      break;
  }
}, initialPart);

export default partReducer;
